/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IconButton } from '@fluentui/react/lib/Button';
import { Modal } from '@fluentui/react/lib/Modal';
import * as React from 'react';
import { ModalSize } from '../../../data/types.generated';
import { ApprovalsLocalization } from '../../../localization';
import { getModalStyles } from './ApprovalsModal.styles';

export interface ApprovalsModalComponentProps {
    isOpen: boolean;
    onRenderContent: () => JSX.Element;
    onDismiss: () => void;
    loc: ApprovalsLocalization;
    size?: ModalSize;
}

const ApprovalsModal: React.FC<ApprovalsModalComponentProps> = (props: ApprovalsModalComponentProps): JSX.Element => {
    const { isOpen, onRenderContent, onDismiss, loc, size } = props;

    return (
        <Modal
            styles={getModalStyles(size)}
            isBlocking={true}
            isOpen={isOpen}
            onDismiss={onDismiss}
            forceFocusInsideTrap={false}
            titleAriaId='approvals-modal-title'
            subtitleAriaId='approvals-modal-subtitle'>
            <IconButton
                iconProps={{
                    iconName: 'Cancel',
                }}
                ariaLabel={loc.strings.modal_close_aria_label}
                title={loc.strings.modal_close_aria_label}
                onClick={onDismiss}
                className='modal-dismiss-button'
            />
            {onRenderContent && onRenderContent()}
        </Modal>
    );
};

// Memorize the component to avoid unneccessary rerendering and a smooth show/hide transition
export const ApprovalsModalComponent = React.memo(ApprovalsModal);
